<template>
  <el-upload
    class="avatar-uploader"
    action="string"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    :http-request="UploadImage"
>
    <img
        v-if="showImageUrl"
        v-bind:style="{width: imageWidth + 'px', height: imageHeight + 'px'}"
        :src="showImageUrl"
        fit="cover"/>
    <i v-else
      v-bind:style="{width: imageWidth + 'px', height: imageHeight + 'px', 'line-height': imageHeight + 'px'}"
      class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>
</template>

<script>
import { actionuploadImg } from '@/api/img'
// import { savePublisher, queryActionList2, deleteActionRow, updatPublisher } from '@/api/sysinfo'
// import { imageTypes } from '../../../../common/utils/constant'
// import { showGlobalLoading, hideGlobalLoading, toastSuccess, toastError, showConfirm, toastInfo } from '../../../../common/utils/ui'
export default {
  name: 'UploadImage',
  data () {
    return {
      imageUrl: ''
    }
  },
  props: {
    // 原生图片链接
    originImageUrl: {
      type: String,
      default: ''
    },
    // 图片宽度
    imageWidth: {
      type: [Number, String],
      default: 200
    },
    // 图片高度
    imageHeight: {
      type: [Number, String],
      default: 200
    },
    // 图片大小,单位是M
    imageSize: {
      type: Number,
      default: 2
    },

    imageId: {
      type: Number,
      required: true
    },

    resetImageUrl: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showImageUrl () {
      if (this.resetImageUrl) {
        return ''
      }
      return this.imageUrl || this.originImageUrl
    }
  },
  methods: {
    // 图片上传
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    // 文件提交
    UploadImage (param) {
      const formData = new FormData()
      formData.append('file', param.file)
      actionuploadImg(formData).then(response => {
        this.imageUrl = response

        this.$emit('upload-result', response, this.imageId)
        this.$nextTick(() => {
          document.body.style.overflow = 'initial'
        })
      })
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < this.imageSize
      if (!isLt2M) {
        this.$message.error(`上传头像图片大小不能超过 ${this.imageSize}MB!`)
      }
      return isLt2M
    }
  }
}
</script>

<style scoped lang="scss">
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 208px;
    text-align: center;
    border: 1px dotted;
    line-height: 200px;
    vertical-align: text-bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/SysManager/ExhibitionInfo/HomeSetup/components/uploadImage.vue